import { FeaturedBadgePlacement, ImageRatio } from 'root/consts';

export enum MenuAddOnItemsDisplayMode {
  Grid = 0,
  Slider = 1,
}

export enum MenuAddOnSliderArrowPosition {
  Inside = 0,
  Outside = 1,
}

export enum MenuAddOnImageResizeMode {
  Crop = 0,
  Fit = 1,
}

export const DEFAULT_MAX_ITEMS_PER_ROW = 3;
export const DEFAULT_ITEMS_PER_LOAD = 24;
export const DEFAULT_SLIDER_ARROW_DISTANCE = 16;
export const DEFAULT_ITEMS_COLUMN_GAP = 20;
export const DEFAULT_ITEMS_ROW_GAP = 40;
export const DEFAULT_BACKGROUND_HORIZONTAL_PADDING = 40;
export const DEFAULT_BACKGROUND_VERTICAL_PADDING = 40;
export const DEFAULT_ITEM_INFO_SIDE_PADDING = 0;
export const DEFAULT_ITEM_VERTICAL_PADDING = 0;
export const DEFAULT_ITEM_IMAGE_RATIO = ImageRatio['1:1'];
export const DEFAULT_ITEM_IMAGE_RESIZE_MODE = MenuAddOnImageResizeMode.Crop;
export const DEFAULT_ITEM_IMAGE_VERTICAL_PADDING = 0;
export const DEFAULT_ITEM_IMAGE_SIDE_PADDING = 0;
export const DEFAULT_FEATURED_BADGE_PLACEMENT = FeaturedBadgePlacement.OnImage;

export const MAX_ITEMS_PER_ROW_MIN = 1;
export const MAX_ITEMS_PER_ROW_MAX = 6;

export const ITEMS_PER_LOAD_MIN = 1;
export const ITEMS_PER_LOAD_MAX = 48;

export const MENU_ADD_ON_SPACING_MIN = 0;
export const MENU_ADD_ON_SPACING_MAX = 200;
export const ITEM_INFO_SIDE_PADDING_MAX = 100;
export const ITEM_IMAGE_PADDING_MAX = 100;

export const SLIDER_ARROW_DISTANCE_MIN = 0;
export const SLIDER_ARROW_DISTANCE_MAX = 120;

export const SLIDER_SCROLL_ANIMATION_DURATION_MS = 300;

export const clampStyleNumber = (value: unknown, fallback: number, min: number, max: number) => {
  const numericValue = typeof value === 'number' ? value : Number(value);
  const resolvedValue = Number.isFinite(numericValue) ? Math.round(numericValue) : fallback;

  return Math.min(Math.max(resolvedValue, min), max);
};
